const DIET_LENGTH_MODE = {
  PREDEFINED: 'PREDEFINED',
  CUSTOM: 'CUSTOM',
};

export default DIET_LENGTH_MODE;
